module.exports = __webpack_public_path__ + "img/Motor_acc_2.8f54eb59.jpg";